// extracted by mini-css-extract-plugin
module.exports = {"rolesRow":"editor_rolesRow__1JXdC","title":"editor_title__1G-QM","rolesGrouptitle":"editor_rolesGrouptitle__1mn9B","rolesItems":"editor_rolesItems__1c5RE"};